import { Outlet, Link, useNavigate, router, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { AppValues, API, ApiAdmin } from "../../Values";
import { Modal, Button, Dropdown } from "react-bootstrap";
import axios from "axios";
import Cookies from "js-cookie";
import LoginCheck from "../../LoginCheckAdmin/page";
import Header_ from "../compoenents/Header_";
export default function ApiSetting() {
  const navigate = useNavigate();
  const [Inputs, setInputs] = useState([]);
  const [errors, Seterrors] = useState("");
  const [Action, SetAction] = useState("");

  //---------ShowModal----------------------------
  const [ShowModal, SetShowModal] = useState(false);
  const handleCloseModal = () => SetShowModal(false);
  const handleShowModal = () => SetShowModal(true);
  //===========Check Login ================
  LoginCheck();
  var admininfo = [];
  var AdminName = "";
  var AdminID = "";
  if (Cookies.get("admininfo")) {
    admininfo = JSON.parse(Cookies.get("admininfo"));
    AdminName = admininfo[0].Name;
    AdminID = admininfo[0].ID;
  }
  const [Data, SetData] = useState([]);
  useEffect(() => {
GetData();

  }, []);
// ---------------------------------

  //-------------------------------------------------------------
  async function GetData() {
    try {
      const post = {
        Action: "GetApi",
      };
      const response = await fetch(ApiAdmin + "/Api_Setting.php", {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data = await response.json();
      console.log(data);
      SetData(data);
      SetAction("AddApi");
    } catch (error) {
      return error;
    }
  }
  //-------------------------------------------------------------
  async function GetApiType(e) {
    try {
      const type = e.target.value;
      const post = {
        type: type,
        Action: "GetApiType",
      };

      const response = await fetch(ApiAdmin + "/Api_Setting.php", {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data = await response.json();
      console.log(data);
      setInputs(data[0]);
      SetAction("AddApi");
    } catch (error) {
      return error;
    }
  }
  //-------------------------------------------------------------
  //----------------------------------------
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
  //--------------------------------
  const handleDubelClick = (e) => {
    const name = e.target.name;
    const value = "";
    setInputs((values) => ({ ...values, [name]: value }));
  };
  //----------------------
  const handleSubmit = async (e) => {
    e.preventDefault();
    SetAction("AddApi");
    const formData = new FormData(e.target);
    const data_ = Object.fromEntries(formData.entries());
    if (window.confirm("هل تريد الحفظ")) {
      try {
        const response = await fetch(ApiAdmin + "/Api_Setting.php", {
          method: "POST",
          body: JSON.stringify(data_),
        });
        console.log(response);
        const data = await response.json();
        if (data.errors != "") {
          Seterrors(data.errors);
          handleShowModal();
        }
        if (data.msg != "") {
          Seterrors(data.msg);
          handleShowModal();
          // GetData();
          // e.target.reset();
        }
        if (response.ok) {
        } else if (response.status === 400) {
          return alert("errorr 400");
        } else {
          return alert("can not save ");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <>
      <Header_ />
      <form method="POST" onSubmit={handleSubmit}>
        <div
          dir="rtl"
          className="row p-0 mt-0 text-end m-auto bg-white  mt-lg-4 mt-md-4 "
          style={{ maxWidth: "600px" }}
        >
          <h3 className="text-orange fw-bold py-1 mt-2">
            <Link to="../admin/Setting">
              <i className="fa-solid fa-chevron-right text-orange bg-light p-1 mx-2 fs-4"></i>
            </Link>
            {" Api Setting "}
          </h3>
          <input type="hidden" name="Action" value={Action} />
          <div dir="ltr" className="col-12">
            <label className="col-form-label">type</label>

            <select
              name="type"
              className="form-control"
              onClick={handleDubelClick}
              onChange={GetApiType}
            >
              <option value=""></option>
              <option value="Google Maps">Google Maps</option>
            </select>
          </div>
          <div dir="ltr" className="col-12">
            <label className="col-form-label">url</label>
            <input
              type="text"
              name="url"
              className="form-control"
              autoComplete="off"
              placeholder=""
              onClick={handleDubelClick}
              onChange={handleChange}
              value={Inputs.url}
            />
          </div>
          <div className="col-12">
            <label className="col-form-label" autoComplete="off">
              Access Token
            </label>
            <input
              type="text"
              name="token"
              className="form-control"
              autoComplete="off"
              placeholder=""
              onClick={handleDubelClick}
              onChange={handleChange}
              value={Inputs.token}
          
            />
          </div>
          <div className="col-12">
            <label className="col-form-label" autoComplete="off">
              other
            </label>
            <input
              type="text"
              name="other"
              className="form-control"
              autoComplete="off"
              placeholder=""
              onClick={handleDubelClick}
              onChange={handleChange}
              value={Inputs.other}
            />
          </div>
          <div className="col-12">
            <label className="col-form-label" autoComplete="off">
              title
            </label>
            <input
              type="text"
              name="title"
              className="form-control"
              autoComplete="off"
              placeholder=""
              onClick={handleDubelClick}
              onChange={handleChange}
              value={Inputs.title}
            />
          </div>
          <div className="col-12 mt-4 mb-4 text-center">
            <button className="btn btn-success w-50 px-4">SAVE</button>
          </div>
        </div>
      </form>
      <MSG />
    </>
  );

  function MSG() {
    return (
      <>
        <Modal show={ShowModal} onHide={handleCloseModal}>
          <Modal.Body>
            <div className="row">
              <div className="col-12 text-center">
                <h4 className="text-start p-0 m-0">خطا </h4>
                <hr />
                <h5 className=" text-center ">{errors}</h5>
                <button
                  onClick={() => handleCloseModal()}
                  className="btn btn-danger w-50 m-3"
                >
                  OK
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
